import { render, staticRenderFns } from "./ProfileAttent.vue?vue&type=template&id=9f222c6a&scoped=true&"
import script from "./ProfileAttent.vue?vue&type=script&lang=js&"
export * from "./ProfileAttent.vue?vue&type=script&lang=js&"
import style0 from "./ProfileAttent.vue?vue&type=style&index=0&id=9f222c6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f222c6a",
  null
  
)

export default component.exports